import classNames from "classnames";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const clx = (...classes: classNames.ArgumentArray) =>
  twMerge(classNames(classes));

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const redactSensitiveFields = <T extends Record<string, any>>(
  obj: T,
  sensitiveKeys: string[],
  sensitivePatterns: RegExp[] = [],
): T => {
  return JSON.parse(JSON.stringify(obj), (key, value) => {
    if (
      sensitiveKeys.includes(key) ||
      sensitivePatterns.some((pattern) => pattern.test(key))
    ) {
      return "[REDACTED]";
    }
    return value;
  });
};

export const hasPublicConnection = (whiteListedIps: string[]) => {
  if (!whiteListedIps?.length) return true;

  if (whiteListedIps?.some((val: string) => val.startsWith("0.0.0.0")))
    return true;
};
